import React, { useState, useEffect } from 'react'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { animateScroll as scroll } from 'react-scroll'
import image1 from '../assets/image1.png'
import { MdKeyboardDoubleArrowDown } from "react-icons/md";

const Hero = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1500);
    return () => clearTimeout(timer);
  }, []);

  const scrollToNextSection = () => {
    const viewportHeight = window.innerHeight - 98;
    scroll.scrollTo(viewportHeight, {
      duration: 1000,
      smooth: true,
      spy: true,
      offset: -98 // Account for navbar height
    });
  };

  return (
    <section className={`relative h-[calc(100vh-98px)] p-12 overflow-hidden md:mx-14 mt-12 ${loading ? 'backdrop-blur-md bg-white/60' : 'bg-gray-900'}`}>
      {loading ? (
        <>
          <Skeleton className="absolute inset-0 w-full h-full z-0" height="100%" width="100%" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', zIndex: 0, borderRadius: 0 }} />
          <div className="absolute inset-0 w-full h-full flex flex-col justify-end items-start max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 z-20">
            <Skeleton height={60} width={350} style={{ marginBottom: 32, borderRadius: 8 }} />
            <Skeleton height={40} width={200} style={{ marginBottom: 16, borderRadius: 8 }} />
          </div>
        </>
      ) : (
        <>
          <div className="absolute inset-0 bg-cover bg-center bg-no-repeat">
            <img src={image1} alt="Construction Background" className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-[#003A7D] bg-opacity-10"></div>
          </div>
          <div className="relative z-10 flex flex-col justify-end items-start h-full mx-auto sm:px-6 lg:px-8">
            <h1 className="text-[2.4rem] md:text-6xl 2xl:text-8xl 2xl:px-14 font-bold text-white mb-24 2xl:mb-32 leading-tight">
              Reliable <br /> Construction. <br />Lasting Impact.
            </h1>
          </div>
          <div 
            className="absolute z-30 bottom-8 right-8 text-white animate-pulse cursor-pointer hover:scale-110 transition-transform duration-300"
            onClick={scrollToNextSection}
          >
            <MdKeyboardDoubleArrowDown size={80} className='animate-bounce'/>
          </div>
        </>
      )}
    </section>
  )
}

export default Hero